import { useDispatch } from 'react-redux';
import { AppDispatch } from '../state/Store.ts';

export const useAppDispatch = () => {
    return useDispatch<AppDispatch>();
};
